<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout row
            justify-center>
    <v-dialog
      v-model="showModal"
      :fullscreen="isFullscreen() && !alwaysModal"
      :max-width="getWidth"
      style="z-index: 2000"
    >
      <v-card :class="[$style.modalWrapper, getStyle]">
        <v-content :class="$style.modalContentContainer">
          <v-layout :class="contentStyles"
                    align-center
                    justify-center
                    column
                    fill-height>
            <div v-if="!alwaysModal"
                 :class="$style.modalHeader">
              <h4 :class="$style.modalTitleMobile">{{ title }}</h4>
              <button :class="$style.modalClose"
                      @click="close()"/>
            </div>
            <div :class="$style.logo">
              <Logo/>
            </div>
            <v-flex v-if="title">
              <h4 :class="$style.modalTitle">{{ title }}</h4>
            </v-flex>
            <slot />
          </v-layout>
        </v-content>
      </v-card>

    </v-dialog>
  </v-layout>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import Logo from '@/components/Logo';

/**
 * Modal dialog for different platforms.
 */
@Component({
  name:       'CommonModal',
  components: {
    Logo,
  },
  props: {
    display:     false,
    width:       '',
    type:        '',
    alwaysModal: {
      type:     Boolean,
      default:  false,
      required: false,
    },
    title:     '',
    name:      '',
    noPadding: {
      type:     Boolean,
      default:  false,
      required: false,
    },
  },
})
export default class CommonModal extends Vue {
  /* Window width starting value */
  windowWidth = window.innerWidth;

  /**
   * Content styles.
   */
  get contentStyles() {
    return [
      this.$style.modalContent,
      { [this.$style.noPadding]: this.noPadding },
    ];
  }

  /**
   * Wraps display prop in computed
   */
  get showModal() {
    return this.display;
  }

  get getWidth() {
    return this.width;
  }

  get getStyle() {
    switch (this.type) {
      case ('BigModal'):
        return this.$style.bigModal;

      case ('AppendModal'):
        return this.$style.appendModal;

      case ('SmallModal'):
        return this.$style.smallModal;

      default:
        return  false;
    }
  }

  /**
   * Trigger toggle modal event to handled in parent component. This is used
   * to prevent mutation properties and perform modal close action from parent
   * component.
   * @param val - New value for drawer
   */
  set showModal(val) {
    this.$emit('toggleModal', this.name, val);
  }

  /**
   * Listens window width change
   * and updates isFullscreen result if necessary
   */
  mounted() {
    window.addEventListener('resize', this.isFullscreen);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.isFullscreen);
  }

  /**
   * Gets actually window width
   * and returns true if the width is lesser than 768
   * where the modal should have fullscreen attribute
   */
  isFullscreen() {
    this.windowWidth = window.innerWidth;

    if (this.windowWidth > 767) {
      return false;
    }

    return true;
  }

  close() {
    this.showModal = false;
  }
}
</script>

<style lang="scss" module>
  @import "@/style/variables.scss";

  $modal-content-color: rgba(248,248,248,0.82);

  .bigModal .modalContent {
    padding: 40px 80px;
    justify-content: flex-start;
  }
  .appendModal .modalContent {
    padding: 40px;
  }
  .smallModal .modalContent {
    padding: 21px 0 10px;
    align-items: stretch;

    &.noPadding {
      padding: 0;
    }
  }
  .bigModal .modalContent > div {
    flex: 0 0 auto;
  }
  .modalHeader {
    position: fixed;
    width: 100%;
    height: 45px;
    left: 0;
    top: 0;
    background-color: $white;
    box-shadow: 0 1px 2px 0 rgba(181,181,181,0.6);
    display: none;
    h4 {
      font-family: 'Gotham', sans-serif;
      font-weight: 700;
      font-size: 15px;
      line-height: 45px;
      text-align: center;
      text-transform: uppercase;
      margin: 0;
    }
  }
  .modalClose {
    position: absolute;
    width: 16px;
    height: 16px;
    left: 16px;
    top: 16px;
    outline: none;
    &::before {
      content: '';
      position: absolute;
      top:8px;
      left: 0;
      width: 16px;
      height: 2px;
      background-color: $black;
      transform: rotate(45deg);
      opacity: 1;
    }
    &::after {
      content: '';
      position: absolute;
      top: 8px;
      left: 0;
      width: 16px;
      height: 2px;
      background-color: $black;
      transform: rotate(-45deg);
      opacity: 1;
    }
  }
  .modalContent .logo {
    display: none;
  }
  .bigModal .modalTitle {
    margin-top: 20px;
    margin-bottom: 24px;
  }

  .smallModal .modalTitle {
    font-family: 'Gotham', sans-serif;
    font-size: 20px;
    margin-bottom: 12px;
    padding: 0 24px;
  }

  .bigModal .modalContent .logo {
    max-width: 169px;
    display: block;
  }
  @media screen and (max-width: $mobile-breakpoint-max) {
    .bigModal .modalContent {
      background-color: $light-cart-bg;
      padding: 100px;
    }
    .bigModal.modalWrapper {
      display: flex;
      flex-direction: column;
    }
    .bigModal .modalContentContainer{
      height: 100%;
    }

    .bigModal .modalHeader {
      display: block;
    }
    .bigModal .modalTitle {
      font-family: 'LP Bambus', sans-serif;
      color: $black-semi-transparent;
      font-size: 24px;
      line-height: 22px;
      font-weight: 400;
      margin-top: 52px;
      margin-bottom: 17px;
    }
  }

  @media screen and (max-width: 630px) {
    .bigModal .modalContent {
      padding: 30px;
      padding-top: 100px;
    }
  }
  @media screen and (max-width: 560px) {
    .appendModal.modalWrapper {
      border-radius: 14px;
    }
    .appendModal .modalContent {
      padding: 19px 0 0;
      background-color: $modal-content-color;
      border-radius: 14px;
    }
    .appendModal .modalTitle {
      font-family: 'Gotham', sans-serif;
      font-size: 17px;
      line-height: 22px;
      font-weight: 700;
      margin-bottom: 24px;
      padding: 0 16px;
    }
    .smallModal.modalWrapper {
      border-radius: 14px;
    }
    .smallModal .modalContent {
      padding: 19px 0 0;
      background-color: $modal-content-color;
      border-radius: 14px;
    }
    .smallModal .modalTitle {
      font-size: 17px;
      margin-bottom: 15px;
      padding: 0 16px;
      text-align: center;
    }
  }
</style>




// WEBPACK FOOTER //
// src/apps/shared/components/CommonModal.vue